<template>
	<div class="revisions" :class="{ active: isViewingRevisions }">
		<h3>Revisions</h3>
		<a href="#" class="close" @click.prevent="handleClickAnywhere">close</a>
		<ul>
			<li class="current-revision"><a href="#" @click.prevent="handleSelectedRevision(latestKnownRevision)">Current Revision</a></li>
			<li v-for="entry in history" v-bind:key="entry._id">
				<a href="#" @click.prevent="handleSelectedRevision(entry.revision)" :title="`View revision ${entry.revision}`" :class="{ active: entry.revision === selectedRevision }">
					{{ formattedDate(entry.date) }}
					<template v-if="entry.author && entry.author.fullName != 'none'"> by {{ entry.author.fullName }}</template>
				</a>
			</li>
		</ul>
	</div>
</template>


<script>

	import PagesService from '@/services/PagesService'
	const dateformat = require('dateformat')

	export default {
		name: 'page-revisions',
		data() {
			return {
				history: Array
			}
		},
		props: ['guid', 'isViewingRevisions', 'selectedRevision', 'latestKnownRevision'],
		watch: {
			isViewingRevisions() {
				this.$store.commit('setShouldHideFlamingo', this.isViewingRevisions)

				if (this.isViewingRevisions) {
					this.getPageHistory()
					document.body.addEventListener('click', this.handleClickAnywhere)
				}
			}
		},
		methods: {
			formattedDate(dt) {
				return dateformat(dt, 'm/d/yy h:MMtt')
			},
			async getPageHistory() {
				const historyResponse = await PagesService.getPageHistory(this.guid)

				this.history = historyResponse.data
			},
			handleSelectedRevision(rev) {
				this.$emit('selected-revision', rev)
			},
			handleClickAnywhere() {
				this.$emit('close-revisions')
				document.body.removeEventListener('click', this.handleClickAnywhere)
			}
		}
	}

</script>


<style lang="scss">

	.revisions {
		position: fixed;
		top: 20%;
		left: -1px;
		bottom: 20%;
		min-width: 200px;
		max-width: 100vh;
		overflow-y: scroll;
		background-color: rgba(0, 0, 0, 0.8);
		border: 1px solid #fff;
		border-top-right-radius: 8px;
		border-bottom-right-radius: 8px;
		box-shadow: 0 0 8px rgba(0, 0, 0, 0.7);
		transform: translateX(-100%);
		opacity: 0;
		transition: transform 0.25s, opacity 0.25s;
		-webkit-backdrop-filter: blur(2px);
		text-align: left;
		
		h3 {
			margin: 0;
			padding: 0 4px 4px 4px;
			color: #fff;
		}

		.close {
			position: absolute;
			top: 0;
			right: 4px;
			font-family: 'Material Icons';
			font-size: 16px;
			color: rgb(209, 207, 207);

			&:hover {
				text-decoration: none;
				color: #fff;
			}
		}

		&.active {
			display: block;
			transform: none;
			opacity: 1.0;
		}

		ul {
			color: #fff;
			list-style-type: none;
			margin: 0;
			padding: 0;
			font-size: 11px;
			line-height: 12px;

			li {
				margin: 0;
				padding: 0;

				&.current-revision {
					margin-bottom: 6px;
					font-style: italic;
				}
			}

			a {
				display: block;
				margin: 2px 6px;
				padding: 0;
				color: #fff;

				&.active {
					background-color: rgba(255, 255, 255, 0.2);

					&:hover {
						background-color: rgba(255, 255, 255, 0.2);
					}
				}

				&:hover {
					text-decoration: none;
					background-color: rgba(255, 255, 255, 0.1);
				}
			}
		}
	}

</style>
